export const DASHBOARD_ACTION_TYPES = {
    SET_SCREEN: 'SET_SCREEN',
    SET_COUNTS_DATA: 'SET_COUNTS_DATA',
    SET_SHOW_UNBLOCK_POP_UP: 'SET_SHOW_UNBLOCK_POP_UP',
    SET_DASHBOARD_CURRENT_DATA: 'SET_DASHBOARD_CURRENT_DATA'
}

const initialState = {
    dashboardCurrentData: null,
    showUnblockPopUp: false,
    screen: 'Dashboard',
    countsData: null
}

const DashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case (DASHBOARD_ACTION_TYPES.SET_SCREEN):
            return {
                ...state,
                screen: action.payload
            }
        case (DASHBOARD_ACTION_TYPES.SET_COUNTS_DATA):
            return {
                ...state,
                countsData: action.payload
            }
        case (DASHBOARD_ACTION_TYPES.SET_SHOW_UNBLOCK_POP_UP):
            return {
                ...state,
                showUnblockPopUp: action.payload
            }
        case (DASHBOARD_ACTION_TYPES.SET_DASHBOARD_CURRENT_DATA):
            return {
                ...state,
                dashboardCurrentData: action.payload
            }
        default:
            return state
    }
}

export default DashboardReducer